export default {
  // 七牛上传图片获取token
  getPicUploadToken: '/member/anonymous/amc/getResourceUploadToken',
  // 七牛上传视频获取token
  getVideoUploadToken: '/member/anonymous/amc/getStreamUploadToken',
  // 七牛上传图片后压缩图片接口
  imageCompression: '/member/anonymous/amc/getPictureInfo',
  // 七牛上传视频后的压缩接口
  videoCompression: '/member/anonymous/amc/getStreamAccessUrlByStreamId',
  // 私有云本地上传
  uploadFile: '/fileupload/uploadFile?encode=utf-8',
  // 私有化上传图片后存储信息
  saveUploadPicture: '/member/anonymous/amc/saveUploadPicture',
  // 私有化上传音视频后的存储信息（单个）
  saveUploadStream: '/member/anonymous/amc/saveUploadStream',
  // 私有化上传音视频后的存储信息（批量）
  saveUploadStreamButch: '/member/anonymous/amc/saveUploadStreamButch',
  // 音视频转码
  transcode: '/transcodenode/videoedit/transcode',
}